export default __webpack_public_path__ + "static/media/SelfDrivingLogo.b9a409c7.png";